export interface ProperNoun {
  id: string
  writtenForm: string
  reading: string
  description: string
  applicableTo: boolean[]
}

// applicableTo の配列インデックス（kansei-api 側の bit 順と一致させる）
export const APPLICABLE_INDEX_AI_RECORD = 0
export const APPLICABLE_INDEX_SUMMARY = 1
export const APPLICABLE_TO_SIZE = 2
